import React, { useEffect, useRef, useState } from "react"
import useModal from "./use-modal"

// Web3Forms access key (https://web3forms.com). Messages are delivered to the
// email address the key was created for; that address never appears on the site.
const accessKey = "fe2c3efc-9260-4b74-bfb5-7709ebe6a632"

const ContactDialog = ({ onClose }) => {
  const [status, setStatus] = useState("idle") // idle | sending | sent | error
  const dialog = useRef(null)
  const firstField = useRef(null)

  useModal(dialog, firstField, onClose)

  useEffect(() => {
    if (status === "sent") dialog.current.focus()
  }, [status])

  const handleSubmit = e => {
    e.preventDefault()
    setStatus("sending")

    const data = new FormData(e.target)
    data.append("access_key", accessKey)
    data.append("subject", "New message from vefside.com")
    data.append("from_name", "vefside.com")

    fetch("https://api.web3forms.com/submit", { method: "POST", body: data })
      .then(res => res.json())
      .then(json => {
        if (!json.success) throw new Error(json.message)
        setStatus("sent")
        if (window.umami) window.umami.track("contact")
      })
      .catch(() => setStatus("error"))
  }

  const handleBackdrop = e => {
    if (e.target === e.currentTarget) onClose()
  }

  return (
    <div className="dialog-backdrop" onMouseDown={handleBackdrop}>
      <div
        className="dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-title"
        tabIndex="-1"
        ref={dialog}
      >
        <button
          type="button"
          className="dialog-close"
          aria-label="Close"
          onClick={onClose}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>

        {status === "sent" ? (
          <>
            <h2 id="contact-title" className="dialog-title">
              Message sent
            </h2>
            <p className="dialog-text">
              Thank you! We'll get back to you by email soon.
            </p>
            <button type="button" className="button" onClick={onClose}>
              Close
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <h2 id="contact-title" className="dialog-title">
              Contact us
            </h2>
            <p className="dialog-text">
              Ask about additional workspaces or anything else. We'll reply by
              email.
            </p>

            <label className="field">
              <span>Name</span>
              <input
                ref={firstField}
                name="name"
                type="text"
                autoComplete="name"
                required
              />
            </label>
            <label className="field">
              <span>Email</span>
              <input name="email" type="email" autoComplete="email" required />
            </label>
            <label className="field">
              <span>Message</span>
              <textarea name="message" rows="5" required />
            </label>

            {/* Spam trap: hidden from people, filled in by bots */}
            <input
              type="checkbox"
              name="botcheck"
              className="honeypot"
              tabIndex="-1"
              autoComplete="off"
            />

            {status === "error" && (
              <p className="form-error" role="alert">
                Something went wrong. Please try again in a moment.
              </p>
            )}

            <button
              type="submit"
              className="button"
              disabled={status === "sending"}
            >
              {status === "sending" ? "Sending…" : "Send message"}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

export default ContactDialog
